import React from 'react';
import {IDatasetSetpointRowConfig} from "./common/api/interfaces/interfaces";
import DatasetButtonComponent from "./DatasetButtonComponent";

import 'react-tooltip/dist/react-tooltip.css'
import './DatasetSetpointRow.scss';

const DatasetSetpointRow = (props: IDatasetSetpointRowConfig) => {
    const datasetData = (props.dataset?.data.length! | 0) > 0 ? props.dataset?.data[0] : null;
    const setpointData = (props.setpointDataset?.data.length! | 0) > 0 ? props.setpointDataset?.data[0] : null;

    const datasetDecimalPlace = props.dataset ?
        props.dataset.decimalPlaces || props.dataset.decimalPlaces === 0 ?
            props.dataset.decimalPlaces
            : 2 : 2;

    const setpointDatasetDecimalPlace = props.setpointDataset ?
        props.setpointDataset.decimalPlaces || props.setpointDataset.decimalPlaces === 0 ?
            props.setpointDataset.decimalPlaces
            : 2 : 2;

    const datasetTime = datasetData?.key ? new Date(datasetData.key as string) : null;
    const setpointTime = setpointData?.key ? new Date(setpointData.key as string) : null;
    const datasetId = props.dataset ? `dataset-label-${props.dataset?.identifier.split(':')[1]}-${props.dataset?.identifier.split(':')[0]}` : null;
    const setpointId = props.setpointDataset ? `setpoint-label-${props.setpointDataset?.identifier.split(':')[1]}-${props.setpointDataset?.identifier.split(':')[0]}` : null;

    const DatasetButton = () => {
        let value: string | undefined;
        if (props.dataset) {
            if (props.dataset.data) {
                if (props.dataset.data.length > 0) {
                    value = props.dataset.data[0].value.toFixed(datasetDecimalPlace);
                }
            }
            return <td onClick={() => {
            }}>
                <DatasetButtonComponent id={datasetId ? datasetId : ""}
                                        value={value}
                                        selected={props.datasetSelected}
                                        setIdentifiers={props.setIdentifiers}
                                        dataset={props.dataset}
                                        data={datasetData}
                                        time={datasetTime!!}
                />
            </td>

        } else {
            return <td></td>
        }
    }

    const SetpointButton = () => {
        let value: string | undefined;
        if (props.setpointDataset) {
            if (props.setpointDataset.data) {
                if (props.setpointDataset.data.length > 0) {
                    value = props.setpointDataset.data[0].value.toFixed(setpointDatasetDecimalPlace);
                }
            }

            return <td>
                <DatasetButtonComponent id={setpointId ? setpointId : ""}
                                        value={value}
                                        selected={props.setpointSelected}
                                        setIdentifiers={props.setIdentifiers}
                                        dataset={props.setpointDataset}
                                        data={setpointData}
                                        time={setpointTime!!}
                />
            </td>

        } else {
            return <td></td>
        }

    }

    return (
        <tr className={"table-row"}>
            {props.showTagColumn === true &&
                <td className={"tag"}>
                    {props.tag}
                </td>
            }

            <td className={"name-wrapper"}>
                {props.name ?
                    props.name
                    :
                    !props.name &&
                    (props.dataset?.title) ?
                        props.dataset.title
                        :
                        props.setpointDataset?.title ?
                            props.setpointDataset.title
                            :
                            <></>
                }
            </td>

            {(props.dataset) ?
                <DatasetButton/>
                :
                <td></td>
            }

            {props.showSetpointColumn &&
                <>
                    {(props.setpointDataset) ?
                        <SetpointButton/>
                        :
                        <td></td>
                    }
                </>
            }
        </tr>
    );
}
export default DatasetSetpointRow;